import { Modal } from "react-bootstrap";

function ConfirmModal({ show, handleClose, onConfirm, content}) {  
  return (
    <Modal 
     show={show} 
     onHide={handleClose} 
     size="md"
     centered            
    >     
        <div>
            <Modal.Header 
                closeButton
                style={{                   
                    backgroundColor:"#dcedc8"
                  }}               
            >          
                <>
                    <Modal.Title><b>{content}</b></Modal.Title>
                </>       
            </Modal.Header>
            <Modal.Body 
                style={{
                    backgroundColor:'#f4faed', 
                    borderRadius:"5px"                  
                }}   
            >
                <div className="d-flex justify-content-center">
                    <button
                        type="submit"
                        className="btn btn-primary mx-3"
                        onClick={()=>onConfirm()}              
                    >
                        Submit
                    </button> 
                    <button
                        type="button"
                        className="btn btn-warning" 
                        onClick ={()=>{handleClose()}}
                    >
                        Cancel
                    </button>  
                </div>
            </Modal.Body>            
        </div>                    
    </Modal>
  );
}

export default ConfirmModal;
